import React from 'react'
import titleLine from '../../assets/title-line.png'
import { Image } from '@chakra-ui/react'
// title line svg
export const VectorTitleLine = React.memo(
  ({ width = '147', color = '#FFE03F' }: { width?: string | number; color?: string }) => {
    const height = (+width / 147) * 19 || '19px'

    return (
      // <svg
      //   width={width}
      //   height={height}
      //   viewBox="0 0 147 19"
      //   fill="none"
      //   xmlns="http://www.w3.org/2000/svg"
      // >
      //   {/* 添加背景模糊的路径 */}
      //   <g filter="url(#backdrop_blur)">
      //     <path d="M3.50001 14H143.5" stroke="url(#paint0_linear)" />
      //   </g>
      //   <path d="M6.50001 10H146.5" stroke="url(#paint1_linear)" />
      //   <defs>
      //     {/* 过滤器：用于模糊背景 */}
      //     <filter
      //       id="backdrop_blur"
      //       x="0"
      //       y="0"
      //       width="147"
      //       height="19"
      //       filterUnits="userSpaceOnUse"
      //     >
      //       <feGaussianBlur stdDeviation="6" result="blurred" />
      //       <feBlend mode="normal" in="SourceGraphic" in2="blurred" result="blended" />
      //     </filter>

      //     {/* 第一条线的渐变 */}
      //     <linearGradient
      //       id="paint0_linear"
      //       x1="143.5"
      //       y1="14.5"
      //       x2="3.5"
      //       y2="14.5"
      //       gradientUnits="userSpaceOnUse"
      //     >
      //       <stop stopColor={`${color}16`} />
      //       <stop offset="1" stopColor="#111019" stopOpacity="0" />
      //     </linearGradient>

      //     {/* 第二条线的渐变 */}
      //     <linearGradient
      //       id="paint1_linear"
      //       x1="146.5"
      //       y1="10.5"
      //       x2="6.5"
      //       y2="10.5"
      //       gradientUnits="userSpaceOnUse"
      //     >
      //       <stop stopColor={color} />
      //       <stop offset="1" stopColor={color} stopOpacity="0" />
      //     </linearGradient>
      //   </defs>
      // </svg>
      <Image src={titleLine} alt="title-line" width={width} height={height} />
    )
  },
)

export default VectorTitleLine
